import { ArcaneGrowthEffect } from 'game/extended/heros/mage/arcane_growth/arcane_growth_effect'

export default {
    events: {},
    effects: {
        ArcaneGrowthEffect
    },
    requirements: {}
}